import { render, staticRenderFns } from "./UserRatedMovies.vue?vue&type=template&id=91b4ecfc&"
import script from "./UserRatedMovies.vue?vue&type=script&lang=js&"
export * from "./UserRatedMovies.vue?vue&type=script&lang=js&"
import style0 from "./UserRatedMovies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserRatedMovies.vue"
export default component.exports